export default () => <div className="knockr-logo"><img src="/img/wordmark.svg" /><sup><strong>TM</strong></sup></div>